var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSpaceBgReflections(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_2",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 1160.49 2405.74",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#fff;opacity:.1;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_1-2"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "0 0 0 1363.2 587.81 3.29 191.72 0 0 0"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "0 1905.53 0 2405.74 1160.49 3.29 884.43 3.29 0 1905.53"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSpaceBgReflections);
export default __webpack_public_path__ + "static/media/space-bg-reflections.757192d527c5adedae388a87cfe650bd.svg";
export { ForwardRef as ReactComponent };